import { lazy } from 'react';

export const ClimateScorecard = lazy(() => import('./ClimateScorecard'));
export const ClimateScorecardVerifyEmail = lazy(() => import('./ClimateScorecardVerifyEmail'));
